import FdnNotification from "@fdn/notification";
import FdnNotificationContainer from "@fdn/notification_container";

export const Desktop = (props) => (
	<FdnNotificationContainer
		id="group-notification"
		width="auto"
		top="var(--fd-space-12)"
		right="0"
		left="auto"
		padding="var(--fd-space-0) var(--fd-space-8) var(--fd-space-0) var(--fd-space-0)"
	>
		<>
			{props.data.map(({
				id, notifId, title, type, buttonText, url, body, ...notif
			}) => (
				<FdnNotification
					isMobile={false}
					id={id}
					key={`${id}-mobile`}
					title={title}
					type={type}
					onClose={props.onClose}
					width="400px"
					duration={3000}
					closeable
					buttonText={buttonText || ""}
					cta={() => props.seenNotif({ ...notif, notifId, url }) || ""}
					body={body || ""}
				/>
			))}

			<style>
				{`
					.notification__learn-more-button {
						border:none !important;
						background:none;
					}
				`}
			</style>
		</>
	</FdnNotificationContainer>
);
